if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('predictive-search-results__inner')) {
            window.dispatchEvent(new Event('scroll'));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('.search-modal__content.dialog-modal');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "open") {
          const isHidden = target.hasAttribute("open");

          if (isHidden) {
            window.dispatchEvent(new Event("scroll"));
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["open"]
    });
  }, 300);
}
